import { t } from 'i18next';
import * as yup from 'yup';
import { strings } from '../../../constants/strings';
import tenantConstants from '@constants';
import { emailValidationYup, phoneValidationYup, stringValidationYup, cnicValidationYup, landlineValidationYup } from '../../../helpers';

export const agencyStaffUserFormFields = (userId = null, cities) => {
  return {
    name: {
      type: 'input',
      value: '',
      validation: () => stringValidationYup(t(strings?.vm?.name)),
      props: {
        label: 'Name',
        placeholder: 'Enter Name',
        maxLength: 80,
      },
    },
    cnic: {
      type: 'input',
      value: '',
      validation: () => userId ? null : cnicValidationYup(),
      props: {
        label: 'CNIC #',
        placeholder: 'XXXXX-XXXXXXX-X',
        maxLength: 15,
        limit: 15,
        inputMode: 'numeric',
        format: 'cnic',
        disabled: !!userId,
      },
    },
    email: {
      type: 'input',
      value: '',
      validation: () => emailValidationYup(),
      props: {
        label: 'Email',
        placeholder: 'Enter Email',
        maxLength: 300,
        disabled: !!userId ? true : false,
      },
    },
    ...(!userId && {
      password: {
        type: 'input',
        value: '',
        show: false,
        validation: () => stringValidationYup(t(strings.vm.password)).min(9, t('Password must be at least 9 characters')),
        props: {
          label: 'Password',
          placeholder: 'Enter Password',
          maxLength: 300,
        },
      },
    }),
    mobile: {
      type: 'phone-input',
      value: '',
      validation: () => phoneValidationYup(true),
      props: {
        label: 'Mobile',
        placeholder: 'Enter Mobile Number',
        defaultCountry: 'PK',
        disabled: !!userId ? true : false,
      },
    },

    landline: {
      type: 'landline-input',
      value: '',
      validation: () => landlineValidationYup(false),
      props: {
        label: 'Landline',
        placeholder: '+92 XX YYYYYYY',
        disabled: !!userId,
      },
    },
    ...(!!userId && {
      olx_listings_number: {
        type: 'input',
        value: '',
        props: {
          label: 'OLX Listing Number',
          placeholder: 'OLX Listing Number',
          disabled: true,
        },
      },
    }),
    city: {
      type: 'select',
      validation: () => stringValidationYup(t(strings.vm.city)).nullable(),
      props: {
        label: tenantConstants.USER_LOCATIONS.label,
        placeholder: `Select  ${tenantConstants.USER_LOCATIONS.label}`,
        options: cities,
      },
    },
    address: {
      type: 'input',
      value: '',
      validation: () => stringValidationYup(strings.vm.address).notRequired(),
      props: {
        label: 'Address',
        placeholder: 'Enter Address',
        maxLength: 250,
      },
    },

    image: {
      type: 'image-select',
      value: [],
      validation: () => null,
      props: {
        label: 'Upload a picture',
        placeholder: 'Browse and Upload',
        multi: false,
        attachmentType: 'user_profile',
      },
    },
    ...(!userId && {
      cnic_front: {
        type: 'image-select',
        value: [],
        validation: () => yup.array().min(1, t('CNIC front is required')).required(t('CNIC front is required')),
        props: {
          label: 'CNIC Front',
          placeholder: 'Browse and Upload',
          multi: false,
          attachmentType: 'user_cnic_front',
        },
      },
      cnic_back: {
        type: 'image-select',
        value: [],
        validation: () => yup.array().min(1, t('CNIC back is required')).required(t('CNIC back is required')),
        props: {
          label: 'CNIC Back',
          placeholder: 'Browse and Upload',
          multi: false,
          attachmentType: 'user_cnic_back',
        },
      },
    }),
  };
};
